module.exports = __webpack_public_path__ + "static/3-cb65e9dab185cfda100e5b159f6492ab.png";